var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"header-wrapper"},[_c('header',{staticClass:"header",class:_vm.headerClasses,style:(_vm.headerStyles)},[_vm._t("default",null,{"useLightTheme":_vm.useLightTheme})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }